import { recordOrigin, type Origin } from '../../lib/origin'
import { Icon } from '../ui'
import './back.css'

// The way back from a single-page task: a form, a send screen, a report
// (release 3.3, Back model B1 and B3).
//
// # WHY THIS EXISTS
//
// Rule B1: a screen has a Back link or breadcrumbs, never both. Records and
// lists have breadcrumbs (components/Crumbs.tsx); a task that is one page has
// this link at its top, and a wizard has neither (its footer's Back and its
// step bar). Before, each task screen wrote its own "Back to ..." with a fixed
// destination, so a report opened from Reports sent the person to Home.
//
// # WHERE IT GOES
//
// To the list the task was opened from, with its filters, when the history
// entry recorded one (lib/origin.ts); otherwise to `fallback`, the task's
// normal parent. It is a plain link, so Ctrl+click and the browser's own
// "open in a new tab" work, and the address it goes to is the one shown on
// hover.

export function backTo(fallback: Origin): Origin {
  return recordOrigin() ?? fallback
}

export function BackLink({ fallback, className }: { fallback: Origin; className?: string }) {
  const to = backTo(fallback)
  return (
    <a className={'kit-back' + (className ? ' ' + className : '')} href={to.href}>
      <span className="kit-back-arrow" aria-hidden="true">
        <Icon name="chevron" size={14} />
      </span>
      Back to {to.label}
    </a>
  )
}
